module.exports = __webpack_public_path__ + "img/ic30StarDark.5b2f6a02.svg";